import { useMemo } from 'react';
import { DomainsStatsWithShare, DomainStatsWithShare } from './UseDomainsStatsShare';

/**
 * Hook to sort domains by count (descending)
 * Used to ensure consistent sorting across components (table and chart)
 */
export const useDomainsStatsSorted = (
  statsWithShare: DomainsStatsWithShare | undefined
): DomainStatsWithShare[] => {
  return useMemo(() => {
    if (!statsWithShare?.domains) {
      return [];
    }

    return [...statsWithShare.domains].sort((a, b) => b.count - a.count);
  }, [statsWithShare]);
};

